module.exports = __webpack_public_path__ + "static/img/search-no.13daa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-no.png
// module id = hW8B
// module chunks = 1